import styled from 'styled-components';

export const LogoStyle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const LogoText = styled.div`
  color: #4a494f;
  font-size: 2rem;
  font-family: 'Poppins';
  font-weight: 700;
`;

export const LogoImage = styled.div`
  width: 2.8rem;
  height: 2.8rem;
`;
